import * as React from 'react'
import clsx from 'clsx'
import { SxProps, sx as sxFunc } from '../sx'
import { useFormControl, formControlState } from '../FormControl'
import style from './index.module.scss'
export interface FormGroupClasses {
  /** Styles applied to the root element. */
  root: string
  /** Styles applied to the root element if `row={true}`. */
  row: string
  /** State class applied to the root element if `error={true}`. */
  error: string
}

export interface FormGroupProps extends React.HTMLAttributes<HTMLDivElement> {
  /**
   * The content of the component.
   */
  children?: React.ReactNode
  /**
   * Override or extend the styles applied to the component.
   */
  classes?: Partial<FormGroupClasses>
  /**
   * Display group of elements in a compact row.
   * @default false
   */
  row?: boolean
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx?: SxProps
}

export const FormGroup = React.forwardRef<HTMLDivElement, FormGroupProps>(
  function FormGroup(props, ref) {
    const { className, classes, row = false, sx, ...other } = props
    const factorFormControl = useFormControl()
    const fcs = formControlState({
      props,
      factorFormControl,
      states: ['error'],
    })

    const _classes = clsx(
      style.root,
      classes?.root,
      row && [style.row, classes?.row],
      fcs.error && [classes?.error],
      className,
      sxFunc(sx)
    )

    return <div className={_classes} ref={ref} {...other} />
  }
)
